// extracted by mini-css-extract-plugin
module.exports = {"error":"lodging_error__PkfU9","accommodation":"lodging_accommodation__yC0GO","header":"lodging_header__jNGGE","offerList":"lodging_offerList__7WQVS"};